import type { SearchSummary } from '@tunasong/models'
import { dayjs, isTimeStamp } from '@tunasong/models'
import { useElementTypeMedia } from '@tunasong/plugin-lib'
import { isProfile } from '@tunasong/schemas'
import { getColorCSS, TagList, TunaBreadcrumbs, capitalize, Typography, ListItemIcon, ListItemText, ListItemSecondaryAction, MenuItem } from '@tunasong/ui-lib'
import type { MenuItemProps } from '@tunasong/ui-lib'
import type { JSX } from 'react'
import React from 'react'
import styles from './search-result-item.module.css'
export interface SearchResultListItemProps extends MenuItemProps {
  className?: string
  icon?: JSX.Element
  element: SearchSummary
  /** Show details */
  showDetails?: boolean
  /** Make the breadcrumbs active links */
  breadCrumbLinks?: boolean
  actions?: React.ReactElement | null
  ref?: React.Ref<HTMLElement>
}

export const SearchResultListItem = (props: SearchResultListItemProps) => {
  const { element, showDetails = true, actions, icon, breadCrumbLinks = true, ref, ...restProps } = props
  const { materialColor: color } = useElementTypeMedia(element.type)

  const details = element?.type ? (
    <Typography variant="caption">
      <TunaBreadcrumbs
        className={styles.breadcrumbs}
        parentChain={[element, ...(element.parentChain ?? [])].reverse()}
        variant="caption"
        showHome={false}
        showLeaf={false}
        activeLinks={breadCrumbLinks}
      />
      <span className={styles.typeLabel} style={{ color: getColorCSS(color) }}>{capitalize(element.type)}</span>.{' '}
      {isTimeStamp(element) ? `Updated ${dayjs(element.updatedAt).fromNow()}` : ''}.
      <TagList
        tags={element.tags}
        size="small"
      />
    </Typography>
  ) : null

  const name = isProfile(element) ? (element.name ?? element.email) : element.name
  return (
    <MenuItem ref={ref} {...restProps}>
      <ListItemIcon>{icon}</ListItemIcon>

      <ListItemText
        className={styles.listItemText}
        primary={
          <Typography className={styles.primaryText}>
            {name}
          </Typography>
        }
        secondary={showDetails ? details : null}
      />

      <ListItemSecondaryAction>{actions}</ListItemSecondaryAction>
    </MenuItem>
  )
}

export default SearchResultListItem
